module.exports = __webpack_public_path__ + "static/img/01.e87c6de.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/01.png
// module id = g2Ap
// module chunks = 1